import React from "react";
import TableActionMenu from "./TableActions/TableActionMenu";
import {
  Badge,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Rating,
  Switch,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import SeeDetailsButton from "./Order/SeeDetailsButton";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { format } from "date-fns";
import camera from "../../assets/svg/camera.svg";
import viewicon from "../../assets/svg/view.svg";
import righticon from "../../assets/svg/right.svg";
import cancelicon from "../../assets/svg/cancel.svg";

export const generateBrandColumns = (actions) => {
  return [
    {
      name: "Brand",
      grow: 2,
      selector: (row) => row?.brand,
      cell: (row) => {
        return (
          <>
            {row.brandLogo ? (
              <img
                src={row.brandLogo}
                style={{ width: "50px", height: "auto", marginRight: "10px" }}
                staticImage
                alt={row.brandName}
              />
            ) : (
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.brandName?.charAt(0).toUpperCase()}
              </div>
            )}
            <Typography
              sx={{ fontSize: "14px", fontWeight: 500, marginLeft: "5px" }}
            >
              {row?.brandName}
            </Typography>
          </>
        );
      },
      // sortable: true,
    },
    {
      name: "Created on",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {new Date(row?.createdAt?.seconds * 1000).toDateString()}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Category",
      // grow: 2,
      selector: (row) => row.brandCategory,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row.brandCategory}
          </Typography>
        );
      },
      // sortable: true,
    },
    {
      name: "Affiliate link",
      // grow: 2,
      selector: (row) => (
        <Typography
          sx={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
        >
          {row?.notAffiliateLink ? "No" : "Yes"}
        </Typography>
      ),
      // sortable: true,
    },
    {
      name: "Location",
      selector: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.brandLocation}
        </Typography>
      ),
      // cell: (row) => <span>{row.brandLocation}</span>,
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Followers",
      selector: (row) => row.followers,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.followers}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Status",
      selector: (row) => row.brandStatus,
      cell: (row) => {
        return (
          row.brandStatus && (
            <Typography
              sx={{
                fontSize: "12px",
                lineHeight: "14px",
                fontWeight: 500,
                paddingX: "8px",
                paddingY: "4px",
                backgroundColor:
                  row?.brandStatus?.toLowerCase() === "active"
                    ? "#2DC58C"
                    : "#EB5757",
                borderRadius: "2px",
                color: "white",
              }}
            >
              {row.brandStatus}
            </Typography>
          )
        );
      },
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Action",
      cell: (row) => {
        const updatedAction = actions.filter((act) => {
          if (act?.actionName === "Approve" || act?.actionName === "Reject") {
            if (row?.brandStatus?.toLowerCase() === "pending") {
              return act;
            }
          } else {
            return act;
          }
        });
        return <TableActionMenu row={row} updatedActionList={updatedAction} />;
      },
      sortable: false,
      // hide: "md",
    },
  ];
};

export const generateDealColumns = (actions) => {
  return [
    {
      name: "Created on",
      selector: (row) => row?.createdAt,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {new Date(row?.createdAt?.seconds * 1000).toDateString()}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Deal Type",
      selector: (row) => row?.dealType,
      cell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              paddingX: "8px",
              paddingY: "4px",
              backgroundColor: row.dealType === "Sales" ? "#9B51E0" : "#2F80ED",
              borderRadius: "2px",
              color: "white",
              whiteSpace: "nowrap",
            }}
          >
            {row.dealType}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Deal Category",
      selector: (row) => row?.dealCategory,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.dealCategory}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Coupon",
      selector: (row) => row.coupon,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.coupon}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Start At",
      selector: (row) => row.startingDate,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {new Date(row?.startingDate?.seconds * 1000).toDateString()}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "End At",
      selector: (row) => row.endDate,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {new Date(row?.endDate?.seconds * 1000).toDateString()}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Review",
      selector: (row) => row.reviewDate,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {new Date(row?.reviewDate?.seconds * 1000).toDateString()}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Featured",
      selector: (row) => row.isFeatureDeal,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.isFeatureDeal ? "Yes" : "no"}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Action",
      cell: (row) => <TableActionMenu row={row} updatedActionList={actions} />,
      // sortable: false,
      // hide: "md",
    },
  ];
};

export const issueColumns = [
  {
    name: "Date",
    grow: 1,
    selector: (row) => row?.createdAt,
    cell: (row) => (
      // <span>{new Date(row?.createdAt?.seconds * 1000).toDateString()}</span>
      <span>{new Date(row?.createdAt?.seconds * 1000).toDateString()}</span>
    ),
  },
  {
    name: "User",
    grow: 1,
    selector: (row) => row?.userName,
    cell: (row) => {
      return (
        <>
          {/* <span className="ps-2 text-info">{row?.userName}</span> */}
          <a
            // href="#"
            onClick={() => {
              const userId = row?.userId;
              const newURL = `/users/user/view/${userId}`;
              window.location.href = newURL;
            }}
            className="text-blue-500"
          >
            {row?.userName}
          </a>
          {/* <span onClick={() => {
            navigate(`/users/user/view/${row?.userId}`)
          }} className="text-blue-500">
            {row?.userName}
          </span> */}
        </>
      );
    },
  },
  {
    name: "User Location",
    grow: 1,
    selector: (row) => row?.userLocation,
    cell: (row) => <span>{row?.userLocation}</span>,
  },
  {
    name: "Issue Type",
    grow: 2,
    selector: (row) => row?.issueType,
    cell: (row) => {
      return <span>{row?.issueType}</span>;
    },
  },
  {
    name: "Note",
    grow: 2,
    selector: (row) => row.note,
    cell: (row) => {
      return <span>{row.note}</span>;
    },
  },
];

export const generateAllDealsColumns = (actions, user) => {
  const arr = [
    {
      name: "Created On",
      grow: 2,
      selector: (row) => row?.createdAt,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {new Date(row?.createdAt?.seconds * 1000).toDateString()}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Deal Type",
      grow: 2,
      selector: (row) => row?.dealType,
      //   cell: (row) => (row.isCarrierPartner ? "Yes" : "No"),
      cell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              paddingX: "8px",
              paddingY: "4px",
              backgroundColor:
                row?.dealType === "Sales" ? "#9B51E0" : "#2F80ED",
              borderRadius: "2px",
              color: "white",
              whiteSpace: "nowrap",
            }}
          >
            {row.dealType}
          </Typography>
        );
      },
    },
    {
      name: "Brand",
      grow: 2,
      selector: (row) => row.brand,
      //   cell: (row) => <span>{`${row.rating.toFixed(2) || 0}/5`}</span>,
      cell: (row) => {
        return (
          // <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          //   {row.brand}
          // </Typography>
          <>
            {row.brandLogo ? (
              <img
                src={row.brandLogo}
                style={{ width: "24px", height: "24px", borderRadius: "50%" }}
                staticImage
                alt={row.brandName}
              />
            ) : row?.brandName ? (
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.brandName?.charAt(0).toUpperCase()}
              </div>
            ) : (
              " "
            )}
            <Typography
              sx={{ fontSize: "14px", fontWeight: 500, marginLeft: "5px" }}
            >
              {row?.brandName}
            </Typography>
          </>
        );
      },
      // sortable: true,
    },
    {
      name: "Deal Category",
      grow: 2,
      selector: (row) => row?.dealCategory,
      //   cell: (row) => <span>{`${row.rating.toFixed(2) || 0}/5`}</span>,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row?.dealCategory}
          </Typography>
        );
      },
      // sortable: true,
    },
    {
      name: "Coupon",
      grow: 2,
      selector: (row) => row?.coupon,
      // sortable: true,
      cell: (row) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
            >
              {row?.coupon}
            </Typography>
          </Box>
        );
      },
    },
    {
      name: "Start At",
      grow: 2,
      selector: (row) => row?.startingDate,
      // sortable: true,
      // hide: "md",
      cell: (row) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
            >
              {new Date(row?.startingDate?.seconds * 1000).toDateString()}
            </Typography>
          </Box>
        );
      },
    },
    {
      name: "End At",
      grow: 2,
      selector: (row) => row?.endDate,
      // sortable: true,
      // hide: "md",
      cell: (row) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
            >
              {new Date(row?.endDate?.seconds * 1000).toDateString()}
            </Typography>
          </Box>
        );
      },
    },
    {
      name: "Review",
      grow: 2,
      selector: (row) => row?.reviewDate,
      // sortable: true,
      // hide: "md",
      cell: (row) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
            >
              {new Date(row?.reviewDate?.seconds * 1000).toDateString()}
            </Typography>
          </Box>
        );
      },
    },
    {
      name: "Featured",
      selector: (row) => row?.isFeatureDeal,
      cell: (row) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {row?.isFeatureDeal ? "Yes" : "no"}
          </Typography>
        );
      },
    },
    {
      name: "Action",
      cell: (row) => {
        // console.log(actions, "actions>>>");
        // console.log(row, "row>>>");
        // const updatedActionList = actions.filter((act) => {
        //   if (act.id === "add-main-address") {
        //     if (row.isRoutePartner) {
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   } else {
        //     return true;
        //   }
        // });
        // console.log(updatedActionList, "updatedActionList>>>");
        return <TableActionMenu row={row} updatedActionList={actions} />;
      },
      sortable: false,
      // hide: "md",
    },
  ];
  //   return user?.role === "Superadmin" || user?.role === "Platform Admin"
  //     ? arr
  //     : arr.filter((a) => a.name !== "action");

  // return arr.filter((a) => a.name !== "action");
  return arr;
};

export const generateStoreColumns = (actions) => {
  return [
    {
      name: "Store",
      // grow: 2,
      selector: (row) => row?.store_name,
      cell: (row) => {
        return (
          <>
            {row.storeImages?.length > 0 ? (
              <img
                src={
                  row?.storeImages?.length > 0
                    ? row?.storeImages[0]
                    : row?.storeImages
                }
                style={{ width: "24px", height: "24px", marginRight: "10px" }}
                staticImage
                alt={row.store_name}
              />
            ) : (
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "4px",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "#fff",
                  fontSize: "14px",
                }}
              >
                {row?.store_name?.charAt(0).toUpperCase()}
              </div>
            )}
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 700,
                marginLeft: "8px",
                color: "background: rgba(28, 38, 48, 1)",
              }}
            >
              {row?.store_name}
            </Typography>
          </>
        );
      },
      // sortable: true,
    },
    {
      name: "Created on",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {/* {new Date(row?.created_on * 1000).toDateString()} */}
          {row?.created_on
            ? format(new Date(row?.created_on), "EEE, MMM dd yyyy")
            : "Date Not Available"}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Rating",
      // grow: 2,
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            marginRight: "5px",
            display: "flex",
            alignItems: "center",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {/* {row?.rating} */}
          <Rating
            name="half-rating"
            defaultValue={row?.rating}
            size="small"
            style={{ marginRight: "5px" }}
          />{" "}
          ({row?.rating})
        </Typography>
      ),
      // sortable: true,
    },
    {
      name: "Total Product",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.total_products}
        </Typography>
      ),
      // cell: (row) => <span>{row.brandLocation}</span>,
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Action",
      cell: (row) => {
        const updatedAction = actions.filter((act) => {
          if (act?.actionName === "Approve" || act?.actionName === "Reject") {
            if (row?.brandStatus?.toLowerCase() === "pending") {
              return act;
            }
          } else {
            return act;
          }
        });
        return <TableActionMenu row={row} updatedActionList={updatedAction} />;
      },
      sortable: false,
      // hide: "md",
    },
  ];
};

export const generateAllProductsColumns = (actions) => {
  return [
    {
      name: "Photo",
      selector: (row) => row?.productImage,
      cell: (row) => {
        return (
          <>
            {row?.productImage ? (
              <img
                src={
                  row?.productImage?.length > 0
                    ? row?.productImage[0]
                    : row?.productImage
                }
                style={{ width: "28px", height: "28px", marginRight: "10px" }}
                staticImage
                alt={row?.productName}
              />
            ) : (
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.productName?.charAt(0).toUpperCase()}
              </div>
            )}
          </>
        );
      },
    },
    {
      name: "Name",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Badge
              sx={{
                "& .MuiBadge-badge": {
                  color: "lightgreen",
                  backgroundColor: row?.productType === true && "blue",
                },
                marginLeft: "15px",
              }}
              variant="dot"
            />
            <span>{row?.productName ? row?.productName : row?.parcelName}</span>
          </div>
        </Typography>
      ),
    },
    {
      name: "Product ID",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productId}
        </Typography>
      ),
    },
    {
      name: "Category",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productCategory?.toUpperCase()}
        </Typography>
      ),
    },
    {
      name: "Price (USD)",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          ${row?.productPrice}
        </Typography>
      ),
    },
    {
      name: "Stock",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productStock}
        </Typography>
      ),
    },
    {
      name: "Status",
      selector: (row) => <Switch checked={row?.productStatus} readOnly />,
    },
    {
      name: "Action",
      cell: (row) => {
        const updatedAction = actions.filter((act) => {
          // if (act.id === "approve" && row.productStatus === false) {
          //   return true;
          // } else if (act.id === "disapprove" && row.productStatus === true) {
          //   return true;
          // }
          return true;
        });
        return <TableActionMenu row={row} updatedActionList={updatedAction} />;
      },
      sortable: false,
    },
  ];
};

export const generateNewProductsColumns = (actions) => {
  return [
    {
      name: "Photo",
      selector: (row) => row?.productImage,
      cell: (row) => {
        return (
          <>
            {row?.productImage ? (
              <img
                src={
                  row?.productImage?.length > 0
                    ? row?.productImage[0]
                    : row?.productImage
                }
                style={{ width: "28px", height: "28px", marginRight: "10px" }}
                staticImage
                alt={row?.productName}
              />
            ) : (
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.productName?.charAt(0).toUpperCase()}
              </div>
            )}
          </>
        );
      },
    },
    {
      name: "Name",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productName}
        </Typography>
      ),
    },
    {
      name: "Category",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productCategory?.toUpperCase()}
        </Typography>
      ),
    },
    {
      name: "Price (USD)",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          ${row?.productPrice}
        </Typography>
      ),
    },
    {
      name: "Stock",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productStock}
        </Typography>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{ cursor: "pointer", marginRight: 2 }}
            onClick={() => actions.onView(row)}
          >
            <img src={viewicon} alt="view" width="20px" height="20px" />
          </Box>
          <Box
            sx={{ cursor: "pointer", marginRight: 2 }}
            onClick={() => actions.onRight(row)}
          >
            <img src={righticon} alt="view" width="20px" height="20px" />
          </Box>
          <Box sx={{ cursor: "pointer" }} onClick={() => actions.onCancel(row)}>
            <img src={cancelicon} alt="view" width="20px" height="20px" />
          </Box>
        </Box>
      ),
      sortable: false,
    },
  ];
};

export const generateUnderReviewProductsColumns = (actions) => {
  return [
    {
      name: "Photo",
      selector: (row) => row?.productImage,
      cell: (row) => {
        return (
          <>
            {row?.productImage ? (
              <img
                src={
                  row?.productImage?.length > 0
                    ? row?.productImage[0]
                    : row?.productImage
                }
                style={{ width: "28px", height: "28px", marginRight: "10px" }}
                staticImage
                alt={row?.productName}
              />
            ) : (
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.productName?.charAt(0).toUpperCase()}
              </div>
            )}
          </>
        );
      },
    },
    {
      name: "Name",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productName}
        </Typography>
      ),
    },
    {
      name: "Category",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productCategory?.toUpperCase()}
        </Typography>
      ),
    },
    {
      name: "Price (USD)",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          ${row?.productPrice}
        </Typography>
      ),
    },
    {
      name: "Stock",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productStock}
        </Typography>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{ cursor: "pointer", marginRight: 2 }}
            onClick={() => actions.onView(row)}
          >
            <img src={viewicon} alt="view" width="20px" height="20px" />
          </Box>
          <Box
            sx={{ cursor: "pointer", marginRight: 2 }}
            onClick={() => actions.onRight(row)}
          >
            <img src={righticon} alt="view" width="20px" height="20px" />
          </Box>
          <Box sx={{ cursor: "pointer" }} onClick={() => actions.onCancel(row)}>
            <img src={cancelicon} alt="view" width="20px" height="20px" />
          </Box>
        </Box>
      ),
      sortable: false,
    },
  ];
};

export const generateOrderColumns = (actions) => {
  return [
    {
      name: "Order ID",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "14px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          #{row?.order_id}
        </Typography>
      ),
    },
    {
      name: "Created on",
      selector: (row) => row.created_on,
      cell: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "14px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {format(new Date(row?.created_on), "EEE, MMM d yyyy")}
        </Typography>
      ),
    },
    {
      name: "Customer",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "14px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.customer}
        </Typography>
      ),
    },
    {
      name: "Total",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "14px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          ${row.total}
        </Typography>
      ),
    },
    {
      name: "Payment",
      selector: (row) => {
        const paymentStatus = row.payment;
        const colors =
          paymentStatus === "Paid"
            ? "#2DC58C"
            : paymentStatus === "Pending"
            ? "#F2994A"
            : "#2DC58C";

        return (
          <Typography
            sx={{
              fontSize: "12px",
              lineHeight: "14px",
              fontWeight: 500,
              backgroundColor: colors,
              color: "white",
              border: `1px solid ${colors}`,
              borderRadius: "2px",
              paddingX: "8px",
              paddingY: "4px",
              height: "22px",
            }}
          >
            {paymentStatus}
          </Typography>
        );
      },
    },
    {
      name: "Fulfilment",
      selector: (row) => {
        const status = row.fulfilment;
        let color;
        if (status === "Picking Up") {
          color = "#EB5757";
        } else if (status === "Packing") {
          color = "#00C3F7";
        } else if (status === "Deliverry") {
          color = "#F2994A";
        } else if (status === "Done") {
          color = "#2DC58C";
        }

        return (
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              backgroundColor: color,
              color: "white",
              border: `1px solid ${color}`,
              borderRadius: "2px",
              paddingX: "8px",
              paddingY: "4px",
              height: "22px",
              lineHeight: "14px",
            }}
          >
            {status}
          </Typography>
        );
      },
    },
    {
      selector: (row) => {
        return <SeeDetailsButton />;
      },
      sortable: false,
    },
  ];
};

export const generateItemColumns = (actions) => {
  return [
    {
      name: "No",
      selector: (row) => (
        <Typography
          sx={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
        >
          {row?.id}
        </Typography>
      ),
    },
    {
      name: "Item Name",
      grow: 2,
      selector: (row) => row?.brand,
      cell: (row) => {
        return (
          <>
            {row.brandLogo ? (
              <img
                src={row.brandLogo}
                style={{ width: "50px", height: "auto", marginRight: "10px" }}
                staticImage
                alt={row.image}
              />
            ) : (
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "12px",
                }}
              >
                {row?.item_name?.charAt(0).toUpperCase()}
              </div>
            )}
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                marginLeft: "5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {row?.item_name?.length > 10
                ? `${row.item_name.slice(0, 10)}...`
                : row?.item_name}{" "}
              <ArrowCircleRightIcon
                sx={{
                  color: "#481AA3",
                  width: "16px",
                  height: "16px",
                  marginLeft: "8px",
                }}
              />
            </Typography>
          </>
        );
      },
    },
    {
      name: "Qty",
      selector: (row) => (
        <Typography
          sx={{ fontSize: "14px", fontWeight: 500, marginRight: "5px" }}
        >
          {row?.qty}
        </Typography>
      ),
    },
    {
      name: "Value",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
          }}
        >
          {row.add_ons}{" "}
          <ArrowCircleRightIcon
            sx={{
              color: "#481AA3",
              width: "16px",
              height: "16px",
              marginLeft: "8px",
            }}
          />
        </Typography>
      ),
    },

    {
      name: "Total",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
          }}
        >
          {row.customslq}{" "}
          <ArrowCircleRightIcon
            sx={{
              color: "#481AA3",
              width: "16px",
              height: "16px",
              marginLeft: "8px",
            }}
          />
        </Typography>
      ),
    },
  ];
};

export const generateCataloguesColumns = (actions) => {
  return [
    {
      name: "Photo",
      selector: (row) => row?.productImage,
      cell: (row) => {
        return (
          <>
            {row?.productImage ? (
              <img
                src={row?.productImage}
                style={{ width: "28px", height: "28px", marginRight: "10px" }}
                staticImage
                alt={row?.productName}
              />
            ) : (
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.productName
                  ? row?.productName?.charAt(0).toUpperCase()
                  : row?.parcelName?.charAt(0).toUpperCase()}
              </div>
            )}
          </>
        );
      },
    },
    {
      name: "Name",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {/* {row?.productName ? row?.productName : row?.parcelName} */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Badge
              sx={{
                "& .MuiBadge-badge": {
                  color: "lightgreen",
                  backgroundColor: row?.productType === true && "blue",
                },
                marginLeft: "15px",
              }}
              variant="dot"
            />
            <span>{row?.productName ? row?.productName : row?.parcelName}</span>
          </div>
        </Typography>
      ),
    },
    {
      name: "Product ID",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productId}
        </Typography>
      ),
    },
    {
      name: "Category",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productCategory?.toUpperCase()}
        </Typography>
      ),
    },
    {
      name: "Price (USD)",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          ${row?.productPrice}
        </Typography>
      ),
    },
    {
      name: "Stock",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "rgba(28, 38, 48, 1)",
          }}
        >
          {row?.productStock}
        </Typography>
      ),
    },
    {
      name: "Status",
      selector: (row) => <Switch />,
    },
    {
      name: "Action",
      cell: (row) => {
        const updatedAction = actions.filter((act) => {
          if (act?.actionName === "Approve" || act?.actionName === "Reject") {
            if (row?.brandStatus?.toLowerCase() === "pending") {
              return act;
            }
          } else {
            return act;
          }
        });
        return <TableActionMenu row={row} updatedActionList={updatedAction} />;
      },
      sortable: false,
    },
  ];
};

export const generateIssueColumns = (actions) => {
  return [
    {
      name: "Date",
      selector: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.date}
        </Typography>
      ),
    },
    {
      name: "User",
      grow: 2,
      selector: (row) => row?.image,
      cell: (row) => {
        return (
          <>
            {row.image ? (
              <img
                src={row.image}
                style={{
                  width: "24px",
                  height: "24px",
                  marginRight: "10px",
                  borderRadius: "100%",
                }}
                staticImage
                alt={row.image}
              />
            ) : (
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.image?.charAt(0).toUpperCase()}
              </div>
            )}
            <Typography
              sx={{ fontSize: "14px", fontWeight: 500, marginLeft: "5px" }}
            >
              {row?.user}
            </Typography>
          </>
        );
      },
    },
    {
      name: "User location",
      selector: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.user_loction}
        </Typography>
      ),
    },
    {
      name: "Issue Type",
      selector: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.issue_type}
        </Typography>
      ),
    },
    {
      name: "Note",
      selector: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.note}
        </Typography>
      ),
    },
  ];
};

export const generateProductListColumns = (actions) => {
  return [
    {
      name: "Photo",
      selector: (row) => row.created_on,
      cell: (row) => {
        return (
          <>
            {row.productImage ? (
              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                <img
                  src={
                    row?.productImage?.length > 0
                      ? row?.productImage[0]
                      : row?.productImage
                  }
                  alt={row.productName}
                  width={"28px"}
                  height={"28px"}
                  style={{
                    borderRadius: "4px",
                  }}
                />
              </Typography>
            ) : (
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "4px",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row?.productName
                  ? row?.productName?.charAt(0).toUpperCase()
                  : row?.parcelName?.charAt(0).toUpperCase()}
              </div>
            )}
          </>
        );
      },
    },
    {
      name: "Name",
      // grow: 2,
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
            cursor: "pointer",
          }}
        >
          {/* {row?.productName ? row?.productName : row?.parcelName} */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Badge
              sx={{
                "& .MuiBadge-badge": {
                  color: "lightgreen",
                  backgroundColor: row?.productType === true && "blue",
                },
                marginLeft: "15px",
              }}
              variant="dot"
            />
            <span>
              <Tooltip
                title={row?.productName ? row?.productName : row?.parcelName}
              >
                {row?.productName ? row?.productName : row?.parcelName}
              </Tooltip>
            </span>
          </div>
        </Typography>
      ),
    },
    {
      name: "Category",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.productCategory}
        </Typography>
      ),
    },
    {
      name: "Price (USD)",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.productPrice}
        </Typography>
      ),
    },
    {
      name: "Stock",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.productStock}
        </Typography>
      ),
    },
    {
      name: "Status",
      selector: (row) => <Switch checked={row?.productStatus} readOnly />,
    },
    {
      name: "Action",
      cell: (row) => {
        const updatedAction = actions.filter((act) => {
          if (act?.actionName === "Approve" || act?.actionName === "Reject") {
            if (row?.brandStatus?.toLowerCase() === "pending") {
              return act;
            }
          } else {
            return act;
          }
        });
        return <TableActionMenu row={row} updatedActionList={updatedAction} />;
      },
      sortable: false,
      // hide: "md",
    },
  ];
};

export const generateVariantColumns = (actions) => {
  return [
    {
      name: "Main",
      selector: (row) => row.created_on,
      cell: (row) => {
        return (
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="male" control={<Radio />} />
            </RadioGroup>
          </FormControl>
        );
      },
    },
    {
      name: "Photo",
      selector: (row) => row.created_on,
      cell: (row) => {
        return (
          <>
            {row.productImage ? (
              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                <img
                  src={row.productImage}
                  alt={row.productName}
                  width={"28px"}
                  height={"28px"}
                  style={{
                    borderRadius: "4px",
                  }}
                />
              </Typography>
            ) : (
              <img
                src={camera}
                alt={row.productName}
                width={"16px"}
                height={"16px"}
              />
            )}
          </>
        );
      },
    },
    {
      name: "Custom Size",
      // grow: 2,
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.customsize}
        </Typography>
      ),
    },
    {
      name: "Custom Color",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.customcolor}
        </Typography>
      ),
    },
    {
      name: "Price (USD)",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.price}
        </Typography>
      ),
    },
    {
      name: "Stock",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.stock}
        </Typography>
      ),
    },
    {
      name: "Weight",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.weight}
        </Typography>
      ),
    },
    {
      name: "Dimention",
      selector: (row) => (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            marginRight: "5px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {row.dimensions}
        </Typography>
      ),
    },
    {
      name: "Status",
      selector: (row) => <Switch checked={true} readOnly />,
    },
  ];
};
